import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "@/assets/Icon/iconfont.css" // 阿里云iconFont图标
import VueLazyload from "vue-lazyload"; //图片懒加载

// Vue.use(VueLazyload);

Vue.use(VueLazyload, {
  // 监听行为懒加载
  listenEvents: [
    'scroll', 
    'wheel', 
    'mousewheel', 
    'resize', 
    'animationend', 
    'transitionend', 
    'touchmove',
    'click',
    'keydown',
    'touchend',
    'touchstart'
  ]
});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// 注册全局组件
// import name from './components/name.vue'
// Vue.component('name',name);
